import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { NAV, COMPANY } from "@/content/site";

export default function NotFound() {
  useSeo({ title: "Página no encontrada | ASSE DECOR Interiorismo", description: "La página que buscas no existe.", path: "/404", noindex: true });
  return (
    <section data-testid="not-found-page" className="flex min-h-[80vh] flex-col items-start justify-center bg-[#F6F4EF] pt-24">
      <div className="container-x">
        <p className="font-serif-it text-7xl text-[#8A6C3E]">404</p>
        <h1 className="mt-4 font-display text-3xl font-light uppercase text-[#1E2228]">Página no encontrada</h1>
        <p className="mt-4 max-w-md text-base text-[#3A414B]">La dirección que has abierto no existe o ha cambiado. Puedes volver a la portada o ir directamente a una sección.</p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Link to="/" data-testid="not-found-home-link" className="btn-dark">Volver a la portada</Link>
          <a href={COMPANY.phoneHref} data-testid="not-found-call-link" className="btn-outline-dark">Llamar {COMPANY.phone}</a>
        </div>
        <nav aria-label="Secciones" className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
          {NAV.map((n) => <Link key={n.id} to={`/#${n.id}`} data-testid={`not-found-nav-${n.id}`} className="link-underline text-sm text-[#1E2228]">{n.label}</Link>)}
        </nav>
      </div>
    </section>
  );
}
